import { useEffect, useRef } from "react";

interface UseLoadMoreNewsProps {
  hasNextPage: boolean;
  scrollHeight: number;
  onLoadMore: () => void;
  isLoadingNews: boolean;
}

export const useLoadMoreNews = ({
  hasNextPage,
  scrollHeight,
  isLoadingNews,
  onLoadMore,
}: UseLoadMoreNewsProps) => {
  const newsListDivRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    newsListDivRef.current = document.querySelector('#news-list');
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const newsListHeight = newsListDivRef.current?.scrollHeight;
      if (
        newsListHeight &&
        !isLoadingNews &&
        hasNextPage &&
        scrollHeight >= newsListHeight
      ) {
        onLoadMore();
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollHeight]);
};
